import { Component, HostListener } from '@angular/core';
import { TenantFolderDto } from 'app/api/models/tenant/tenantFolderDto';
import { TenantTeamDto } from 'app/api/models/tenant/tenantTeamDto';
import { TenantsService } from 'app/state/tenants.service';
import { Table } from 'primeng/table';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-tenant-teams',
  templateUrl: './tenant-teams.component.html',
  styleUrl: './tenant-teams.component.scss',
})
export class TenantTeamsComponent {
  constructor(private tenantService: TenantsService) {}
  deleteConfirmation: TenantTeamDto | null = null;

  teams: TenantTeamDto[] = [];
  newTeamText: string = '';
  innerWidth = 0;
  @HostListener('window:resize', ['$event'])
  ngOnInit(): void {
    this.refreshData();
    this.innerWidth = window.innerWidth;
  }
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  addTeam() {
    if (this.newTeamText.trim()) {
      let newTeam = new TenantTeamDto();
      newTeam.name = this.newTeamText;
      this.tenantService
        .addTenantTeam(newTeam)
        .pipe(untilDestroyed(this))
        .subscribe((x) => {
          this.refreshData();
          this.newTeamText = '';
        });
    }
  }

  refreshData() {
    this.tenantService.getAllTenantsTeams().subscribe((x) => {
      this.teams = x;
    });
  }

  handleDeleteClick(team: TenantTeamDto) {
    this.tenantService.deleteTenantTeam(team.id!).subscribe(() => {
      this.refreshData();
    });
  }

  onGlobalFilter(table: Table, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    table.filterGlobal(inputElement.value, 'contains');
  }
}
